import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CheckCircle2, ArrowRight, Sparkles } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function PaymentSuccess() {
  const { user } = useAuth();
  const nav = useNavigate();

  // Redirecionar após alguns segundos se preferir, ou deixar o usuário clicar
  /*
  useEffect(() => {
    const timer = setTimeout(() => nav("/app/dashboard"), 5000);
    return () => clearTimeout(timer);
  }, [nav]);
  */

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-6">
      <Card className="max-w-md w-full p-10 text-center bg-white border border-black/10 rounded-none shadow-editorial relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-[#D9381E]" />
        
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <CheckCircle2 className="w-20 h-20 text-[#D9381E] stroke-1" />
            <Sparkles className="w-6 h-6 text-[#D9381E] absolute -top-2 -right-2 animate-pulse" />
          </div>
        </div>

        <h1 className="font-serif text-4xl mb-4">Acesso Liberado!</h1>
        <p className="text-[#4A4A4A] mb-10 leading-relaxed">
          Seu pagamento foi confirmado com sucesso. <br/>
          O plano <strong>{user?.plan?.toUpperCase()}</strong> já está ativo na sua conta.
        </p>

        <div className="space-y-4">
          <Link to="/app/dashboard">
            <Button className="w-full bg-black hover:bg-black/80 text-white rounded-none py-6 flex items-center justify-center gap-2">
              Ir para o Painel <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>

        <p className="mt-8 text-xs font-mono text-[#8A8A8A] uppercase tracking-widest">
          Obrigado por confiar no RevisaPro
        </p>
      </Card>
    </div>
  );
}
